import { Signal } from '@angular/core';
import { CategoryItemModel, CategoryModel } from '../models/category.model';
import { Result } from '../models/http-response.model';

export abstract class CategoriesRepositoryQuery {
  abstract categories: Signal<CategoryItemModel[]>;
}

export abstract class CategoriesRepository extends CategoriesRepositoryQuery {
  abstract getCategories(): Promise<Result<CategoryItemModel[], Error>>;
  abstract getCategory(idOrSlug: string): Promise<Result<CategoryModel, Error>>;
}
